import { media, styled } from '@styles';

export const Wrapper = styled.div`
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h5FontSize};

  margin: 1em 0;
`;

export const List = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  &:last-child {
    margin-right: 0 !important;
    margin-bottom: 0 !important;
  }
  ${media.smallScreen`
    margin-right: 0;
    margin-bottom: 1em;
  `}
`;

export const Image = styled.div`
  vertical-align: middle;
  margin-right: 20px;
  height: 60px;
  width: 75px;
  ${media.largeScreen`
    height: 50px;
    width: 60px;
  `}
  ${media.mediumScreen`
    margin-right: 12px;
  `}
  ${media.smallScreen`
    width: 45px;
    height: 34px;
  `}
  img {
    width: auto;
    height: 100%;
    max-width: 100%;
  }
`;
